"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tema = exports.gradientes = exports.colors = void 0;
var react_1 = __importDefault(require("react"));
var emotion_theming_1 = require("emotion-theming");
var grays = ["#333333", "#4F4F4F", "#828282", "#BDBDBD", "#E0E0E0", "#EDEDED", "#F2F2F2", "#F7F7F7", "#555"];
var blues = ["#002043", "#00346B", "#0C62A4", "#436790", "#8399B3"];
var objectifyArray = function (array, keyPrefix) {
  return array.reduce(function (acc, value, index) {
    var _a;
    return __assign(__assign({}, acc), (_a = {}, _a["" + keyPrefix + index] = value, _a));
  }, {});
};
exports.colors = __assign(__assign({
  primary: "#E86D30",
  secondary: "#DC4754",
  negativo: "#E85757",
  positivo: "#219653",
  amarelo: "#F2994A",
  white: "#fff"
}, objectifyArray(grays, "gray")), objectifyArray(blues, "blue"));
exports.gradientes = {
  primary: "linear-gradient(90deg, " + exports.colors.primary + " 0%, " + exports.colors.secondary + " 100%)",
  primaryOpacity90: "linear-gradient(90deg, " + exports.colors.primary + "E6 0%, " + exports.colors.secondary + "E6 100%)"
};
var tema = {
  colors: exports.colors,
  fonts: {
    heading: "Nunito",
    body: "Nunito"
  },
  spaces: [0, 8, 16, 24, 32],
  fontWeights: {
    body: 400,
    heading: 700,
    bold: 700
  },
  shadows: {
    padrao: "0px 6px 8px 0px rgba(0, 0, 0, 0.11)"
  },
  buttons: {
    primary: {
      "--cor-da-fonte": "white",
      background: exports.gradientes.primary,
      fontFamily: "heading",
      fontWeight: "bold",
      color: "var(--cor-da-fonte)",
      paddingY: [2, 3],
      paddingX: [3, 4],
      fontSize: [1, 2],
      borderRadius: 999,
      borderColor: "secondary",
      borderWidth: "1px",
      borderStyle: "solid",
      lineHeight: 1.375,
      cursor: "pointer",
      transition: "transform 0.2s ease",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      userSelect: "none",
      "&:hover:not(:disabled):not(.carregando)": {
        transform: "scale(1.072)"
      },
      "&:focus": {
        background: exports.gradientes.primaryOpacity90,
        outline: "none"
      },
      "&:active": {
        background: exports.gradientes.primaryOpacity90
      },
      "&:disabled": {
        background: "none",
        borderColor: "gray4",
        cursor: "not-allowed",
        backgroundColor: "gray4"
      },
      ".indicador-de-carregamento": {
        display: "block",
        size: ["19px", "22px"],
        color: "inherit",
        circle: {
          stroke: "var(--cor-da-fonte)"
        }
      },
      "&.carregando": {
        cursor: "wait",
        pointerEvents: "none"
      },
      "&.delineado:disabled": {
        "--cor-da-fonte": exports.colors.blue4,
        background: "none",
        backgroundColor: "transparent",
        color: "var(--cor-da-fonte)",
        borderColor: "var(--cor-da-fonte)"
      },
      "&.bordado": {
        "--cor-da-fonte": exports.colors.blue4,
        background: "none",
        backgroundColor: "transparent",
        color: "var(--cor-da-fonte)",
        borderColor: "var(--cor-da-fonte)",
        "&:disabled": {
          "--cor-da-fonte": exports.colors.gray4,
          borderColor: "gray4"
        }
      },
      "&.secundario": {
        "--cor-da-fonte": exports.colors.primary,
        borderWidth: 2,
        borderColor: exports.colors.primary,
        background: "none",
        backgroundColor: "transparent",
        "&:hover:not(:disabled)": {
          "--cor-da-fonte": "white",
          background: exports.gradientes.primary
        },
        "&:disabled": {
          "--cor-da-fonte": exports.colors.gray4,
          borderColor: "gray4"
        }
      },
      "&.terciario": {
        "--cor-da-fonte": "white",
        borderColor: exports.colors.primary,
        background: "none",
        backgroundColor: "transparent",
        "&:disabled": {
          "--cor-da-fonte": exports.colors.gray4,
          borderColor: "gray4"
        }
      },
      "&.transparente": {
        "--cor-da-fonte": exports.colors.blue4,
        background: "transparent",
        fontWeight: "normal",
        border: "none",
        "&:disabled": {
          "--cor-da-fonte": exports.colors.gray4
        },
        "&:hover,&:active": {
          transform: "none !important",
          "--cor-da-fonte": exports.colors.blue1
        }
      },
      "&.apoio": {
        "--cor-da-fonte": "white",
        background: exports.colors.blue2,
        borderColor: exports.colors.blue2,
        fontWeight: "normal",
        borderRadius: 3,
        paddingY: 2,
        paddingX: 3,
        "&:hover": {
          transform: "none !important",
          background: exports.colors.blue2 + "e6",
          borderColor: exports.colors.blue2 + "e6"
        },
        "&:active": {
          background: exports.colors.blue2 + "f2",
          borderColor: exports.colors.blue2 + "f2"
        },
        "&:disabled": {
          "--cor-da-fonte": exports.colors.blue4,
          borderColor: exports.colors.blue4,
          background: "transparent"
        }
      }
    }
  }
};
exports.default = tema;
var Tema = function (_a) {
  var children = _a.children;
  return react_1.default.createElement(emotion_theming_1.ThemeProvider, {
    theme: tema
  }, children);
};
exports.Tema = Tema;